import React from "react";
import usersQueries from "../../../requests/queries/UsersQueries";
import "../../../components/pages/users/AuthStyles.css";
import tokens from "../../../utils/token";
import { useState } from "react";

const Login = () => {

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();

    setIsLoading(true);
    setError(null);

    usersQueries.login(event.target.username.value, event.target.password.value)
      .then((res) => {
        if(res.data.token) {
          tokens.user_token.setToken(res.data.token);
          window.location.href = '/admin/dashboard';
        } else {
          setError(res.data.message);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setError(err.response.data.message);
      });
  };

  return (
    <div className="auth-container">
      <div className="logo-container">
        <img 
          src="/patricians.png" 
          alt="Patricians Logo" 
          className="logo-image"
          width={350}
        />
      </div>
      <div className="auth-card">
        <h2 className="auth-title">LOGIN</h2>
        <p className="auth-subtitle">Sign in to your account</p>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="username" className="form-label">Username</label>
            <input 
              type="text" 
              className="form-control" 
              id="username" 
              name="username" 
              placeholder="Enter your username"
              required 
            />
          </div>
          
          <div className="mb-4">
            <label htmlFor="password" className="form-label">Password</label>
            <input 
              type="password" 
              className="form-control" 
              id="password" 
              name="password" 
              placeholder="Enter your password"
              required 
            />
          </div>
          
          <button disabled={isLoading} type="submit" className="btn btn-auth">
            {isLoading ? 'Signing in...' : 'Sign in'}
          </button>
          {error && <div className="error-message mt-3 mb-3">{error}</div>}
        </form>
        
        <a href="/register" className="auth-link">
          Don't have an account? Create one
        </a>
      </div>
    </div>
  );
};

export default Login;
